import { Injectable, PLATFORM_ID, Inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class BrowserDetectionService {
  private readonly userAgent: string;

  constructor(@Inject(PLATFORM_ID) private platformId: Object) {
    this.userAgent = isPlatformBrowser(this.platformId)
      ? window.navigator.userAgent.toLowerCase()
      : '';
  }

  isIOSSafari(): boolean {
    if (!isPlatformBrowser(this.platformId)) {
      return false;
    }

    const isIOS = /iphone|ipad|ipod/.test(this.userAgent);
    const isSafari = /safari/.test(this.userAgent);
    const isChrome = /crios/.test(this.userAgent);
    const isFirefox = /fxios/.test(this.userAgent);

    // On iOS, if it's Safari, the string will include 'safari'
    // but Chrome and Firefox will include 'crios' and 'fxios' respectively
    return isIOS && isSafari && !isChrome && !isFirefox;
  }

  // Additional helper methods
  isIOS(): boolean {
    return isPlatformBrowser(this.platformId) &&
      /iphone|ipad|ipod/.test(this.userAgent);
  }

  isSafari(): boolean {
    return isPlatformBrowser(this.platformId) &&
      /safari/.test(this.userAgent) &&
      !/chrome|chromium|crios|fxios/.test(this.userAgent);
  }

  isAndroid(): boolean {
    return isPlatformBrowser(this.platformId) &&
      /android/.test(this.userAgent);
  }

  isMobileOs() {
    return this.isIOS() || this.isAndroid();
  }

  isAndroidChrome(): boolean {
    return isPlatformBrowser(this.platformId) &&
      /android/.test(this.userAgent) &&
      /chrome|chromium/.test(this.userAgent) &&
      !/samsung/.test(this.userAgent); // Exclude Samsung browser
  }
}
